<va-filter2-model [filterGroup]="filterGroup" [isLoading]="dataSource?.loading$ | async">
  <va-filter-toolbar-actions>
    <button mat-stroked-button [disabled]="(exportLoading$$ | async) === true" (click)="export()">
      <glxy-button-loading-indicator [isLoading]="exportLoading$$ | async">
        <mat-icon class="mdc-button__icon export-icon">cloud_download</mat-icon>
        <label class="mdc-button__label export-label">{{ 'SUBSCRIPTIONS.EXPORT.LABEL' | translate }}</label>
      </glxy-button-loading-indicator>
    </button>
  </va-filter-toolbar-actions>
  <va-filter-content>
    <va-mat-table>
      <table mat-table [dataSource]="dataSource" aria-label="Subscriptions">
        <!-- Customer Name Column -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef>Account</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="businessSelectable; else unselectableBusiness">
              <a class="cell-title" routerLink="{{ businessRoute(row.customerId) }}" [matTooltip]="businessTooltip">
                {{ row.customerName || row.customerId }}
              </a>
            </ng-container>
            <ng-template #unselectableBusiness>
              {{ row.customerName || row.customerId }}
            </ng-template>
            <div class="cell-subtitle">{{ customerSubtitle(row) }}</div>
          </td>
        </ng-container>

        <!-- Product Name Column -->
        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="productSelectable; else unselectableProduct">
              <a class="cell-title" routerLink="{{ skuRoute(row.sku) }}" [matTooltip]="productTooltip">
                {{ row.productName || row.sku }}
              </a>
            </ng-container>
            <ng-template #unselectableProduct>
              {{ row.productName || row.sku }}
            </ng-template>
            <!-- display SKU as subtitle only if it wasn't used for the primary title -->
            <div class="cell-subtitle" *ngIf="row.productName">
              {{ row.sku }}
            </div>
          </td>
        </ng-container>

        <!-- Start Date Column -->
        <ng-container matColumnDef="start">
          <th mat-header-cell *matHeaderCellDef class="date-padding">Start Date</th>
          <td mat-cell *matCellDef="let row" class="date-padding">
            {{ row.billingStart | date: 'mediumDate' }}
          </td>
        </ng-container>

        <!-- End Date Column -->
        <ng-container matColumnDef="end">
          <th mat-header-cell *matHeaderCellDef class="date-padding">End Date</th>
          <td mat-cell *matCellDef="let row" class="date-padding">
            {{ row.expiry | date: 'mediumDate' }}
          </td>
        </ng-container>

        <!-- Frequency Column -->
        <ng-container matColumnDef="frequency">
          <th mat-header-cell *matHeaderCellDef class="date-padding">Frequency</th>
          <td mat-cell *matCellDef="let row" class="date-padding">
            {{ row.frequency | frequency }}
          </td>
        </ng-container>

        <!-- Next Renewal Date Column -->
        <ng-container matColumnDef="nextRenewal">
          <th mat-header-cell *matHeaderCellDef class="date-padding">Next Renewal Date</th>
          <td mat-cell *matCellDef="let row" class="date-padding">
            <span [ngStyle]="{ display: row.willRenew ? 'initial' : 'none' }">{{
              row.nextRenewal | date: 'mediumDate'
            }}</span>
          </td>
        </ng-container>

        <!-- Custom Unit Price Column -->
        <ng-container matColumnDef="customUnitPrice">
          <th mat-header-cell *matHeaderCellDef billingUiPriceColumnStyle>Custom Unit Price</th>
          <td mat-cell *matCellDef="let row" billingUiPriceColumnStyle>
            {{ row.customUnitPrice / 100 || '' | currency }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <div class="flex-row">
              <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="changeRenewal(row)" [disabled]="!hasRenewalDate(row)">
                  <mat-icon>calendar_today</mat-icon>
                  <span>Change Next Renewal</span>
                </button>
                <button mat-menu-item (click)="changeFrequency(row)">
                  <mat-icon>update</mat-icon>
                  <span>Change Frequency</span>
                </button>
                <button mat-menu-item (click)="changePrice(row)" [disabled]="!hasCustomUnitPrice(row)">
                  <mat-icon>attach_money</mat-icon>
                  <span>Change Price</span>
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <ng-content
        *ngIf="(length$ | async) === 0 && (dataSource.loading$ | async) === false"
        select="[empty-state]"
      ></ng-content>
      <mat-paginator
        #subscriptionPaginator
        [length]="length$ | async"
        [pageIndex]="0"
        [pageSize]="25"
        [pageSizeOptions]="[25, 50, 100, 250]"
      ></mat-paginator>
    </va-mat-table>
  </va-filter-content>
</va-filter2-model>
